import script from "./AnimationPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationPreview.vue?vue&type=script&setup=true&lang=js"

import "./AnimationPreview.vue?vue&type=style&index=0&id=23de2d5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23de2d5a"]])

export default __exports__